/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDownFilled: {
  name: 'down-filled';
  data: string;
} = {
  name: 'down-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.999 7.894c-.4.086-.802.401-.994.776-.2.393-.191.959.022 1.387.079.159.748.85 3.087 3.185 3.435 3.431 3.177 3.218 3.886 3.218s.451.213 3.886-3.218c2.339-2.335 3.008-3.026 3.087-3.185.308-.619.19-1.341-.294-1.794a1.441 1.441 0 0 0-1.28-.383c-.503.091-.485.076-3.029 2.613L12 12.857l-2.37-2.364c-2.529-2.522-2.527-2.52-3.009-2.609-.281-.052-.335-.052-.622.01"/></svg>`
};
